
<div id="top-of-page"></div>
<router-outlet (activate)="onActive()">
  @if (progress()) {
    <div class="wrap-container">
      <div class="pre-loader">
        <div class="show-box">
          <svg
            class="spinner"
            width="65px"
            height="65px"
            viewBox="0 0 66 66"
            xmlns="http://www.w3.org/2000/svg"
            >
            <circle
              class="path"
              fill="none"
              stroke-width="6"
              stroke-linecap="round"
              cx="33"
              cy="33"
              r="30"
            ></circle>
          </svg>
        </div>
        <p class="loading-p mat-body-2">Loading please wait ....</p>
      </div>
    </div>
  }
</router-outlet>

<!--
Work-around: render one mat-icon so the Material Icons .woff2 is fetched and can be cached by the SW
for offline use on routes that do not otherwise use mat-icon. Uses Tailwind sr-only (off-layout);
cdk-visually-hidden was not styled here (no CDK a11y global CSS in angular.json), so the block
was still taking vertical space and could add a page scrollbar.
-->
<div class="sr-only" aria-hidden="true">
  <mat-icon>&nbsp;</mat-icon>
</div>
